'use client';

import { motion } from 'motion/react';
import Image from 'next/image';
import React from 'react';

const AnimatedToggler: React.FC<{
  items: any[];
  activeIndex: number;
  onToggle: (index: number) => void;
}> = React.memo(({ items, activeIndex, onToggle }) => {
  return (
    <nav className="relative mt-10 flex w-full max-w-[1440px] justify-center rounded-lg p-2">
      <motion.ul className="relative z-10 flex flex-wrap justify-center gap-2">
        {items.map((item, index) => (
          <motion.li
            key={item.buttonTitle}
            className={`relative flex min-w-[200px] cursor-pointer items-center justify-center rounded-lg px-6 py-3 text-[1.5rem] transition-colors duration-200 ease-linear ${
              index === activeIndex ? 'text-white' : 'text-white/70 hover:text-white'
            } `}
            onClick={() => onToggle(index)}
          >
            {index === activeIndex && (
              <motion.div
                layoutId="active-tab-indicator-product-carousel"
                className="absolute inset-0 z-0 rounded-lg bg-white/10"
                transition={{ type: 'spring', stiffness: 200, damping: 20, mass: 1 }}
              />
            )}

            <div className="relative z-10 flex items-center">
              {item.buttonIcon?.url && (
                <Image
                  src={item.buttonIcon.url}
                  alt={item.buttonIcon.description || item.buttonIcon.title}
                  width={25}
                  height={25}
                  sizes="25px"
                  draggable={false}
                  className="mr-3 inline h-auto w-auto min-w-[25px] object-contain"
                />
              )}
              <span>{item.buttonTitle}</span>
            </div>
          </motion.li>
        ))}
      </motion.ul>
    </nav>
  );
});

AnimatedToggler.displayName = 'AnimatedToggler';

export default AnimatedToggler;
